// extracted by mini-css-extract-plugin
export default {"avatar":"fm1XBM8bwAeUgJ95TmMn","name":"JPLRyGg1p1fM7CtxtMsQ","focused":"ZbInR5gCGfxThYVhWhe9","highlight":"JV8LADmqZA2d9VIof6b8"};